import { render } from "./vstatementuser.vue?vue&type=template&id=763f4eab&scoped=true"
import script from "./vstatementuser.vue?vue&type=script&lang=js"
export * from "./vstatementuser.vue?vue&type=script&lang=js"

import "./vstatementuser.vue?vue&type=style&index=0&id=763f4eab&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f4eab"]])

export default __exports__